// extracted by mini-css-extract-plugin
export default {"container":"Search_container__85CQj","input":"Search_input__M9Sjs","clearButton":"Search_clearButton__0W6QM","icon":"Search_icon__crfT2"};